import {NodeSpec} from 'prosemirror-model'


export const codeBlock: NodeSpec = {
    attrs: {
        lang: {default: null},
        display: {default: "normal"},
    },
    content: "text*",
    marks: "",
    group: "block",
    code: true,
    defining: true,
    dragHandle: true,
    parseDOM: [{
        tag: "pre",
        preserveWhitespace: "full",
        getAttrs: e => ({
            lang: e.getAttribute("lang"),
            display: e.getAttribute("data-display") || "normal",
        })
    }],
    toDOM: e => ["pre", {
        lang: e.attrs.lang,
        "data-display": e.attrs.display,
    }, 0]
}
